import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Define process.env if not available
if (typeof process === 'undefined') {
  window.process = { env: { NODE_ENV: 'development' } }
}

// Import translation files
import enTranslations from './locales/en.json'
import esTranslations from './locales/es.json'

// Define supported languages
export const SUPPORTED_LANGUAGES = ['en', 'es']

const resources = {
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['navigator', 'localStorage', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      checkWhitelist: true,
      htmlTag: document.documentElement,
    },
    react: {
      useSuspense: false,
    },
  })

// Function to get browser language
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage
  return browserLang.split('-')[0] // Get primary language code (e.g., 'es' from 'es-ES')
}

// Set initial language based on browser
const browserLang = getBrowserLanguage()
if (SUPPORTED_LANGUAGES.includes(browserLang)) {
  i18n.changeLanguage(browserLang)
}

export default i18n
